import { cn } from "@/lib/utils";
import { google, office365, yahoo, ics } from "calendar-link";
import Link from "next/link";
import {
  Credenza,
  CredenzaContent,
  CredenzaDescription,
  CredenzaHeader,
  CredenzaTitle,
  CredenzaTrigger,
} from "@/components/ui/credenza";
import { Button } from "../ui/button";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { useRouter } from "next/router";
import { DateTime } from "luxon";

export default function EventDate({ event, className }: any) {
  const { locale } = useRouter();

  const config = {
    title: event.name?.toString(),
    location: event.venue?.name,
    description: event.description,
    start: event.startDate,
    end: event.startDate,
  };

  return (
    <Credenza>
      <CredenzaTrigger asChild>
        <div
          className={cn(
            className,
            "flex flex-row hover:bg-primary/5 p-2 -mx-2 rounded-xl cursor-pointer",
          )}
        >
          <div className="flex items-center w-14">
            <div className="flex flex-col w-10 h-10 overflow-hidden border rounded-lg border-primary/10">
              <div
                className="border-b border-primary/10 bg-primary/20 h-5 text-[10px] font-semibold uppercase flex items-center w-full justify-center"
                suppressHydrationWarning
              >
                {DateTime.fromISO(event.startDate)
                  .toFormat("MMMM", {
                    locale,
                  })
                  .substring(0, 4)}
              </div>
              <div
                className="flex items-center justify-center w-full h-8 font-semibold"
                suppressHydrationWarning
              >
                {DateTime.fromISO(event.startDate).toFormat("dd", { locale })}
              </div>
            </div>
          </div>
          <div>
            <div className="flex flex-col">
              <div
                className="flex items-center w-full h-6 font-medium capitalize "
                suppressHydrationWarning
              >
                {DateTime.fromISO(event.startDate).toFormat("cccc dd MMMM", {
                  locale,
                })}

                <ArrowUpRight className="h-4 opacity-50" />
              </div>
              <div
                className="flex flex-row items-center gap-1 text-sm text-muted-foreground dark:text-accent-foreground/50"
                suppressHydrationWarning
              >
                {DateTime.fromISO(event.startDate).toFormat("HH:mm", {
                  locale,
                })}
                {event.endDate && <ArrowRight className="w-3 h-3" />}{" "}
                {event.endDate &&
                  (DateTime.fromISO(event.endDate).hasSame(
                    DateTime.fromISO(event.startDate),
                    "day",
                  )
                    ? DateTime.fromISO(event.endDate).toFormat("HH:mm", {
                        locale,
                      })
                    : DateTime.fromISO(event.endDate).toFormat(
                        "DD '🕒' HH'h'",
                        {
                          locale,
                        },
                      ))}
              </div>
            </div>
          </div>
        </div>
      </CredenzaTrigger>
      <CredenzaContent className="p-4 md:max-w-xs">
        <CredenzaHeader>
          <CredenzaTitle>Add this event to your calendar</CredenzaTitle>
          <CredenzaDescription>
            Choose your calendar type to get a reminder
          </CredenzaDescription>
        </CredenzaHeader>
        <div className="flex flex-col gap-2">
          <Link href={google(config)} target="_blank">
            <Button className="w-full">Google Calendar</Button>
          </Link>
          <Link href={yahoo(config)} target="_blank">
            <Button className="w-full">Yahoo Calendar</Button>
          </Link>
          <Link href={office365(config)} target="_blank">
            <Button className="w-full">Office 360 Calendar</Button>
          </Link>
          <Link href={ics(config)} target="_blank">
            <Button className="w-full">iCal</Button>
          </Link>
        </div>
      </CredenzaContent>
    </Credenza>
  );
}
